import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';
import { cn } from '@/lib/cn';

interface Props {
  block: ContentBlock;
}

export const HeadingBlock = memo(function HeadingBlock({ block }: Props) {
  if (!block.text) return null;

  const level = Math.min(Math.max(block.level ?? 2, 1), 4);
  const Tag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4';

  return (
    <Tag
      className={cn(
        'mt-2 mb-0.5 font-bold leading-[1.25] text-fg',
        level === 1 && 'text-2xl',
        level === 2 && 'text-xl',
        level === 3 && 'text-lg',
        level === 4 && 'text-base',
      )}
    >
      {block.text}
    </Tag>
  );
});
